import logo from './logonew.png';
export const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';
export const baseURL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';
//Hi Trent
// REMOVE cfApiToken and the direct Cloudflare URL entirely
// baseURLdyte now points at YOUR backend instead
export const baseURLdyte = '/api/realtimekit'; // or full path if your axios baseURL isn't already set

// baseURLdyteMeeting stays for now — separate task, see note at the end
export const baseURLdyteMeeting = 'https://app.dyte.io/v2';


export const logoImage =logo
// export const logoImage ="https://lider-impulz.vercel.app/static/media/logo1.775c2acf99492d8c08fd.png"

const now = new Date();
export const timestamp = now.toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);
